<div class="accordion" id="accordionExample" style="margin-top: -25px;">
    <div class="accordion-item">
        <h2 class="accordion-header" id="heading0">
            <button class="accordion-button collapsed" type="button" data-bs-toggle="collapse"
                    data-bs-target="#collapse0" aria-expanded="false" aria-controls="collapse0">
                Meer banen of uitkeringen tegelijk
            </button>
        </h2>
        <div id="collapse0" class="accordion-collapse collapse" aria-labelledby="heading0"
             data-bs-parent="#accordionExample">
            <div class="accordion-body">
                Bij het indienen van een verzoek of wijziging voorlopige aanslag wordt een berekening gemaakt van de
                verschuldigde inkomstenbelasting en premie volksverzekeringen. Daarbij houden we rekening met de reeds
                gedurende het jaar ingehouden loonheffing.

                <div class="space10"></div>

                <b>Inkomsten over dezelfde periode?</b><br/>
                In geval van 2 of meer banen en/of uitkeringen over eenzelfde periode zal er waarschijnlijk bij een
                ervan de loonheffingskorting toegepast zijn. Bij het andere loon en/of uitkering zal er dan geen
                rekening gehouden zijn met de loonheffingskortingen. Voor de berekening van de verschuldigde belasting
                en premies is dus van belang of de inkomsten tegelijk geweest zijn. Is dat het geval, beantwoord de
                vraag dan met 'Ja'.

                <div class="space10"></div>

                Zijn de inkomsten in het jaar {{ this.year }} niet tegelijk geweest, maar betreft het verschillende
                (niet-overlappende) periodes? Beantwoord de vraag dan met 'Nee'.

            </div>
        </div>
    </div>
    <div class="accordion-item">
        <h2 class="accordion-header" id="heading1">
            <button class="accordion-button collapsed" type="button" data-bs-toggle="collapse"
                    data-bs-target="#collapse1" aria-expanded="false" aria-controls="collapse1">
                Wanneer is er sprake van meer banen of uitkeringen tegelijk
            </button>
        </h2>
        <div id="collapse1" class="accordion-collapse collapse" aria-labelledby="heading1"
             data-bs-parent="#accordionExample">
            <div class="accordion-body">
                Kies 'Ja' in de volgende situaties:
                <li>Er zijn tegelijk 2 of meer banen, bijvoorbeeld 2 parttimebanen.</li>
                <li>Er zijn tegelijk 2 of meer uitkeringen die de aangever van 2 verschillende instanties krijgt. Hij/zij krijgt bijvoorbeeld
                pensioen van een pensioenfonds en een AOW-uitkering rechtstreeks van de Sociale Verzekeringsbank.
                </li>
                <li>Er zijn tegelijk een baan en een uitkering en de aangever ontvangt het loon en de uitkering van 2 verschillende
                instanties. Hij/zij krijgt bijvoorbeeld uw loon van uw werkgever en een gedeeltelijke
                arbeidsongeschiktheidsuitkering van de uitkeringsinstantie.</li>

                <div class="space10"></div>

                In deze gevallen kan de voorlopige aanslag afwijken van de definitieve aanslag inkomstenbelasting. Over
                het geheel van de inkomsten wordt dan te weinig loonheffing ingehouden. Dit komt omdat de werkgevers
                niet van elkaar weten welke loonheffing er wordt ingehouden.

            </div>
        </div>
    </div>

</div>

